module.exports = {
    formatPrice: (value, decimals) => {
        let val = (value / 1).toFixed(decimals).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
}